import SampleAnalyticsPage from './Dashboard';
export default SampleAnalyticsPage;
